<template>
  <nav>
    <router-link to="/">Home</router-link>
    <router-link to="/about">Über mich</router-link>
    <!--<router-link to="/info">Info</router-link>-->
    <router-link to="/contact">Kontakt</router-link>
    <!--<router-link to="/admin">Admin</router-link>-->
  </nav>
  <div class="title-screen">
    <img src="../src/assets/logo-removebg.png" alt="logo">
  </div>
  <router-view />
  <SiteFooter />
</template>

<script>
import SiteFooter from './components/SiteFooter.vue'
export default { components: { SiteFooter } }
</script>


<style>
@font-face {
  font-family: "SamsungSans-Light";
  src: url('./assets/fonts/SamsungSans-Light.ttf') format('truetype');
}

@font-face {
  font-family: "SamsungSans-Thin";
  src: url('./assets/fonts/SamsungSans-Thin.ttf') format('truetype');
}

@font-face {
  font-family: "SamsungSans-Medium";
  src: url('./assets/fonts/SamsungSans-Medium.ttf') format('truetype');
}

@font-face {
  font-family: "SamsungSans-Regular";
  src: url('./assets/fonts/SamsungSans-Regular.ttf') format('truetype');
}

@font-face {
  font-family: "SamsungSans-Bold";
  src: url('./assets/fonts/SamsungSans-Bold.ttf') format('truetype');
}

html,
body {
  padding: 0;
  margin: 0;
  background-color: black;
}

#app {
  font-family: SamsungSans-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;
  background-color: black;
  color: white;
}

nav a {
  font-weight: light;
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  padding: 0 1.5vh;
  transition: .2s;
}

nav a:hover {
  color: #999999;
}

nav a.router-link-exact-active {
  color: #999999;
}

.title-screen {
  background-image: url(../src/assets/img/titel-bild.jpeg);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  height: 900px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-screen img {
  width: 55vh;
}

@media (max-width: 768px) {
  .title-screen {
    background-attachment: scroll;
    /* Standardverhalten für Mobilgeräte */
  }
}
</style>
